require('./RAHireFundRow.scss');
//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
//@commons
const RAOneLineSymbolAmount = require('../RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
//@utilities
const CurrencyHelper = require('utilities/currencyHelper');
const { FormattedText } = require('core/i18n').i18n;

class RAHireFundRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    }

    handleCheckboxClick(evt) {
        const { item, accountId } = this.props;
        this.props.onUpdateCheckbox(
            evt.target.checked,
            item.get('contractNumber'),
            accountId,
            item.getIn(['balance', 'amount']),
        );
    }

    buildRentabilityLabel(rentability, rentabilityPercentage) {
        const formattedRentability = CurrencyHelper.buildAbsoluteFormattedValue(
            rentability,
        );
        const formattedPercentage = CurrencyHelper.formatPercentage(
            rentabilityPercentage,
        );
        return (
            <FormattedText
                value="raHireFundRow-raHireFundRow_rentabilityValue"
                injectedStrings={[formattedRentability, formattedPercentage]}
            />
        );
    }
    render() {
        const { item, hasCheckBox, statusCheckbox, disabledRow } = this.props;
        const actualCgdNumber = item.get('contractNumber');
        const hiddenTextClasses = classNames('ra-hire-fund-row', {
            'ra-hire-fund-row__row--disabled': disabledRow,
        });

        const fundNameLabel = item.get('name');
        const fundName = (
            <span className="ra-hire-fund-row__name">{fundNameLabel}</span>
        );
        const checkoxCell = hasCheckBox ? (
            <div>
                <OKCheckbox
                    disabled={disabledRow}
                    label={fundName}
                    idName={actualCgdNumber}
                    onChange={this.handleCheckboxClick}
                    value={statusCheckbox}
                />
            </div>
        ) : (
            fundName
        );
        const rentability = item.get('rentability');
        const rentabilityPercentage = item.get('rentabilityPercentage');
        const shares = CurrencyHelper.formatAmount(item.get('shares'), null, 5);
        const balance = item.get('balance');
        const rentabilityLabel = !!rentability ? (
            this.buildRentabilityLabel(rentability, rentabilityPercentage)
        ) : (
            <FormattedText value="broker-myInvestmentsNotAvailableInitials" />
        );
        return (
            <OKTableRow className={hiddenTextClasses} key={actualCgdNumber}>
                <OKTableCell className="ra-hire-fund-row__fund">
                    {checkoxCell}
                </OKTableCell>
                <OKTableCell className="ra-hire-fund-row__rentability">
                    {rentabilityLabel}
                </OKTableCell>
                <OKTableCell className="ra-hire-fund-row__shares">
                    {shares}
                </OKTableCell>
                <OKTableCell className="ra-hire-fund-row__balance">
                    <RAOneLineSymbolAmount amountObject={balance} />
                </OKTableCell>
            </OKTableRow>
        );
    }
}

RAHireFundRow.propTypes = {
    accountId: PropTypes.string,
    item: PropTypes.object.isRequired,
    hasCheckBox: PropTypes.bool,
    disabledRow: PropTypes.bool,
    statusCheckbox: PropTypes.bool,
    onUpdateCheckbox: PropTypes.func,
};

RAHireFundRow.defaultProps = {
    hasCheckBox: false,
    disabledRow: false,
};

module.exports = RAHireFundRow;
